let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6Btng"), load("9CRBg")]).then(() => parcelRequire('hCU0r'));